export const CURRENCY = "€";
export const PERLAS_GO_PLANS = "https://perlasenergija.lt/planai/";
export const PERLAS_GO_INSURANCE = "https://perlodraudimas.lt";
export const PERLAS_GO_CAR_INSURANCE = "https://perlodraudimas.lt/automobiliu-draudimo-skaiciuokle/";
export const GOOGLE_PLAY_APP_LINK = "https://play.google.com/store/apps/details?id=lt.perlas.eperlas";
export const APPLE_STORE_APP_LINK = "https://apps.apple.com/lt/app/perlas-go/id1455082113";
export const HUAWEY_APP_GALLERY_APP_LINK = "https://appgallery.huawei.com/app/C102348599";
export const GSM_KEYWORD = "gsm";
export const CHARITY = "Parama";
export const TERMINAL_ERROR_CODES = "terminalErrorCodes";
export const mobileVendors = {
  HUAWEY: "Huawei",
  APPLE: "Apple",
};
export const mobileOs = {
  ANDROID: "Android",
};
